module.exports = __webpack_public_path__ + "static/media/MD.a5f71e34.webp";